export const environment = {
  production: false,
  useEmulators: false,
  enableApiDebugLogs: false,
  cmsApiBaseUrl: 'https://staging-cms-api-mnfnjkt2gq-uc.a.run.app',
  orgId: '697c19ed57a96c84dab8d195',
  firebase: {
    apiKey: 'AIzaSyDiifH1w6-0IOLIx9WoRM1GniGBCDYSyhE',
    authDomain: 'tromso-6a6ca.firebaseapp.com',
    projectId: 'tromso-6a6ca',
    storageBucket: 'tromso-6a6ca.firebasestorage.app',
    messagingSenderId: '178617584798',
    appId: '1:178617584798:web:c8576a82e8b5e53977bf8f',
    measurementId: 'G-0SEDTE6EV4'
  }
};
